"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenuItem = exports.StyledMenuItemLink = exports.MenuItemSecondary = exports.MenuItemPrimary = exports.FullWidthDivider = exports.GroupHeaderText = exports.menuItemStyle = exports.ButtonText = exports.GroupItems = exports.GroupHeader = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var material_1 = require("@mui/material");
var colors_1 = require("../ThemeProvider/colors");
var MenuItemLink_1 = __importDefault(require("../MenuItem/MenuItemLink"));
var MenuItem_1 = __importDefault(require("../MenuItem"));
exports.GroupHeader = (0, styled_1.default)('div')({
    boxSizing: 'border-box',
    lineHeight: '32px',
    listStyle: 'none',
    marginLeft: '-8px',
    paddingLeft: '16px',
    position: 'sticky',
    fontSize: '12px',
    backgroundColor: 'white',
    top: 0,
    zIndex: 1,
});
exports.GroupItems = (0, styled_1.default)('ul')({
    padding: 0,
    fontSize: '14px',
});
exports.ButtonText = (0, styled_1.default)('div')({
    display: 'flex',
    alignItems: 'center',
});
exports.menuItemStyle = {
    display: 'flex',
    paddingRight: '8px',
    justifyContent: 'space-between',
    marginTop: '4px',
};
exports.GroupHeaderText = (0, styled_1.default)(material_1.Typography)({
    fontSize: '12px',
    color: colors_1.tannerGray['600'],
});
exports.FullWidthDivider = (0, styled_1.default)(material_1.Divider)({
    margin: '8px -8px',
});
exports.MenuItemPrimary = (0, styled_1.default)(material_1.Typography)({
    fontWeight: 500,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
});
exports.MenuItemSecondary = (0, styled_1.default)(material_1.Typography)({
    color: colors_1.tannerGray['600'],
    marginLeft: '8px',
});
exports.StyledMenuItemLink = (0, styled_1.default)(MenuItemLink_1.default)(__assign({}, exports.menuItemStyle));
exports.StyledMenuItem = (0, styled_1.default)(MenuItem_1.default)(__assign({ cursor: 'auto' }, exports.menuItemStyle));
//# sourceMappingURL=styles.js.map